import { API_BASE_URL, LOCAL_STORAGE_KEYS, APP_NAME } from '../constants';

const request = async (options) => {
    const headers = options.headers || {};

    if (localStorage.getItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN)) {
        headers['Authorization'] = 'Bearer ' + localStorage.getItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
    }

    if (APP_NAME) {
        headers['App-Name'] = APP_NAME;
    }

    const fetchOptions = {
        method: options.method,
        headers: headers,
    };

    if (options.body) {
        fetchOptions.body = options.body;
    }

    return fetch(options.url, fetchOptions)
        .then(response =>
            response.json().then(json => {
                if (!response.ok) {
                    json = Object.assign({}, { status: response.status }, json);
                    return Promise.reject(json);
                }
                return json;
            })
        );
};

export function handleLogout() {
  localStorage.removeItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
  localStorage.removeItem(LOCAL_STORAGE_KEYS.CURRENT_CLIENT);
  window.location.href = '/connexion';
}

export async function exeRequest(relativeUrl, method, data) {
  const isFormData = data instanceof FormData;

  let options = {
    url: API_BASE_URL + relativeUrl,
    method: method,
    headers: {},
  };

  if (!isFormData) {
    options.headers['Content-Type'] = 'application/json';
    if (data && Object.keys(data).length > 0) {
      options.body = JSON.stringify(data);
    }
  } else {
    options.body = data;
  }

  try {
    return await request(options);
  } catch (error) {
    if (error.status === 401) {
      handleLogout();
    } else {
      console.error("Erreur API:", error);
      throw error;
    }
  }
}
